import { MediumDestination } from '@/entities/enums/MediumDestination';
import { MediumPrefix } from '@/entities/enums/MediumPrefix';
import { isFromEnum } from '@/utils/isFromEnum';
export function getPlaceSearchMediumAttributeFunction(cta) {
    return function (originPlaceType, destinationPlaceType) {
        return getMediumAttribute(cta, originPlaceType, destinationPlaceType);
    };
}
export function getMediumAttribute(cta, originPlaceType, destination) {
    const isMediumDestination = isFromEnum(MediumDestination);
    const destinationString = isMediumDestination(destination)
        ? destination
        : `${MediumPrefix.PRICE_MAP}_${destination}`;
    return `${MediumPrefix.PRICE_MAP}_${originPlaceType}_${cta}_${destinationString}`;
}
export function getUrlWithMediumAttribute({ url, cta, originPlaceType, destination, }) {
    if (typeof window === 'undefined') {
        return url;
    }
    if (window.isUser) {
        return `${url}?m=${getMediumAttribute(cta, originPlaceType, destination)}`;
    }
    return url;
}
